import * as THREE from "../../libs/three.js/build/three.module.js";
import { RenderController } from "../render/RenderController.js";

export class ScenePack extends THREE.Scene {
    constructor(options) {
		super(options);
		this.options = options;
		this.scenes = {};
    this.tiles = {};
	}

    addTile(tileName) {
        const tile = new THREE.Object3D();
        this.tiles[tileName] = tile;
        super.add(tile);
        return tile;
    }

    getTile(tileName) {
        return this.tiles[tileName];
    }

    clearTile(tileName) {
        const tile = this.getTile(tileName);
        tile.clear();
    }

    add(item) {
        super.add(item);
    }

    addToTile(item, tileName) {
        const tile = this.getTile(tileName);
        tile.add(item);
    }

    clear() {
        super.clear();
        this.tiles = {};
    }
}

